import { paletteFor, type SystemPalette } from '@playnets/data';

/**
 * A region's palette is swapped wholesale as you travel (§10) — and that has to
 * include the page, not just the playfield. The plate is drawn by Pixi from
 * these same numbers; this writes them onto the DOM so the poster margin, the
 * build panel and every button move with it.
 */
const hex = (n: number): string => `#${n.toString(16).padStart(6, '0')}`;

export function applyRegionTheme(el: HTMLElement | null, regionId: string): SystemPalette {
  const p = paletteFor(regionId);
  if (el) {
    el.style.setProperty('--void', hex(p.void));
    el.style.setProperty('--paper', hex(p.paper));
    el.style.setProperty('--hot', hex(p.hot));
    el.style.setProperty('--ring', hex(p.ring));
    el.style.setProperty('--threat', hex(p.threat));
    el.style.setProperty('--juice', hex(p.juice));
    // The page ground is the region's paper, so the margin travels too.
    document.body.style.backgroundColor = hex(p.paper);
  }
  return p;
}
